import { render, staticRenderFns } from "./UnreportPost.vue?vue&type=template&id=78f8aa48&scoped=true"
import script from "./UnreportPost.vue?vue&type=script&lang=js"
export * from "./UnreportPost.vue?vue&type=script&lang=js"
import style0 from "./UnreportPost.vue?vue&type=style&index=0&id=78f8aa48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f8aa48",
  null
  
)

export default component.exports